// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"award-summary-wrap__wrap--2oHgK"};